import { useLocation, useNavigate } from "react-router-dom";
import "./otp.css";
import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import { getSurveyById, surveyOtp } from "../../../../api/services/survey-apis";
import { createOTP, validateOTP } from "../../../../api/services/otp-apis";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import axios from "axios";

const Otp: React.FC = () => {
  const [email, setEmail] = useState("");
  const [requestId, setRequestId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const surveyId = new URLSearchParams(location.search).get("surveyId");

  useEffect(() => {
    if (surveyId) {
      fetchEmailAndSendOtp(surveyId);
    }
    const Id = generateId();
    setRequestId(Id);
    console.log("ID:", Id);
  }, [surveyId]);

  // useEffect(() => {
  //   if (requestId) {
  //     logRequestId(requestId);
  //     sendOtpEmail(email);
  //   //   if (email) {
  //   //     sendOtpEmail(email);
  //   //   }
  //   }
  // }, [requestId]);

  useEffect(() => {
    if (requestId && email && !otpSent) {
      console.log("Sending OTP now...");
      logRequestId(requestId);
      sendOtpEmail(email);
      setOtpSent(true); // Mark as sent
    } else if (otpSent) {
      console.log("OTP already sent, skipping...");
    }
  }, [requestId, email, otpSent]);

  const logRequestId = (id: string) => {
    console.log("reqId in logRequestId:", id);
    console.log("RequestID::", requestId);
  };

  function generateId() {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  const fetchEmailAndSendOtp = async (surveyId: string) => {
    try {
      console.log(`Fetching email for surveyId: ${surveyId}`);

      // Fetch the survey data based on the survey ID
      // const response = await axios.get(
      //   `${process.env.REACT_APP_SURVEYID_BASE_URL}${surveyId}`
      // );
      const response = await getSurveyById(surveyId);
      const fetchedEmail = response.data.email;
      setEmail(fetchedEmail);
      console.log("Fetched email:", fetchedEmail);
    } catch (error) {
      console.error("Error fetching email:", error);
      toast.error("Error fetching email");
    }
  };

  const sendOtpEmail = async (email: string) => {
    const createOtpPayload = {
      requestId,
      surveyId,
    };

    console.log("Calling createOTP API with:", createOtpPayload);

    console.log("requestId:", requestId);
    try {
      // await axios.post(`${process.env.REACT_APP_OTP_CREATION_BASE_URL}`, {
      //   requestId,
      //   surveyId,
      // });
      await createOTP(createOtpPayload);
      toast.success("OTP sent successfully!");
      console.log("OTP sent successfully to:", email);
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Error sending OTP");
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setOtp(e.target.value);
  };

  const handleSubmit = async (e: FormEvent) => {
    const validateOtpPayload = {
      requestId,
      otpValue: otp,
    };

    e.preventDefault();
    console.log("RequestID:", requestId);
    console.log("Generated RequestID:", requestId);

    try {
      // const response = await axios.post(
      //   `${process.env.REACT_APP_OTP_VALIDATION_BASE_URL}`,
      //   { requestId, otpValue: otp }
      // );
      const response = await validateOTP(validateOtpPayload);

      console.log("OTP Validation Response:", response.data);

      // Check if the response contains non-null requestId and surveyId
      if (response.data.requestId && response.data.surveyId) {
        navigate(`/survey?surveyId=${surveyId}`, {
          state: { surveyId: response.data.surveyId },
        });
      } else {
        toast.error("Wrong OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error validating OTP:", error);
      toast.error("Wrong OTP. Please try again.");
    }

    console.log("otp entered", otp);
  };

  return (
    <div className="otp-container">
      <div className="otp-content">
        <h3>We have sent an OTP to your email</h3>
        <p>Please enter the OTP below:</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={otp}
            onChange={handleInputChange}
            placeholder="Enter OTP"
            className="otp-input"
          />
          <br />
          <button type="submit" className="otp-submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Otp;
